export const OMM_STATUS_OPTIONS = {
  DRAFT: 'draft',
  SUBMITTED_FOR_PROCESSING: 'submitted for processing',
  PROCESSING: 'processing',
  PROCESSED: 'processed',
  SUBMITTED_FOR_DELIVERY: 'submitted for delivery',
  DELIVERING: 'delivering',
  DELIVERED: 'delivered',
  INVALID: 'invalid',
  SIZE_LOW: 'size_low',
}

export const OMM_REPORTS_STATUS_OPTIONS = {
  DRAFT: 'draft',
  REQUESTED: 'requested',
  GENERATING: 'generating',
  READY: 'ready',
}

export const SCHEMA = {
  NAME: 'name',
  CAMPAIGN_OBJECTIVE: 'campaignObjective',
  COUNTRIES: 'countries',
  BRAND_NAME: 'brandName',
  PRODUCT_NAME: 'productName',
  PRODUCT_NAMES: 'productNames',
  LOOKBACK: 'lookback',
  DELIVERY_DESTINATION: 'deliveryDestination',
  EMAIL_NOTIFICATION: 'emailNotification',
  URLS: 'urls',
}

export const DESTINATION = {
  STATSOCIAL: 'StatSocial',
  CINT: 'CINT',
  CRITEO: 'Criteo',
}

export const DESTINATION_TITLES = {
  [DESTINATION.STATSOCIAL]: 'ID type: hem_md5',
  [DESTINATION.CINT]: 'ID type: lotame',
  [DESTINATION.CRITEO]: 'ID type: ios_id, android_id',
}

export const COUNTRIES_OPTIONS = [
  {
    label: 'Global',
    value: ['all'],
    destinationOptions: [DESTINATION.CINT, DESTINATION.CRITEO],
  },
  {
    label: 'United States - US',
    value: ['US'],
    destinationOptions: [DESTINATION.STATSOCIAL, DESTINATION.CINT, DESTINATION.CRITEO],
  },
  {
    label: 'United Kingdom - GB',
    value: ['GB'],
    destinationOptions: [DESTINATION.CINT, DESTINATION.CRITEO],
  },
  {
    label: 'European Union - EU',
    value: [
      'BE',
      'EL',
      'LT',
      'PT',
      'BG',
      'ES',
      'LU',
      'RO',
      'CZ',
      'FR',
      'HU',
      'SI',
      'DK',
      'HR',
      'MT',
      'SK',
      'DE',
      'IT',
      'NL',
      'FI',
      'EE',
      'CY',
      'AT',
      'SE',
      'IE',
      'LV',
      'PL',
      'IS',
      'NO',
      'LI',
      'CH',
    ],
    destinationOptions: [DESTINATION.CINT, DESTINATION.CRITEO],
  },
]

export const LOOKBACK_OPTIONS = [
  '7 Days',
  '14 Days',
  '30 Days',
  // '90 Days'
]
